module.exports = __webpack_public_path__ + "img/de.9cde5357.svg";